// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2ktl-","tableRowStyle":"styles_tableRowStyle__2zG4_","actionTableCell":"styles_actionTableCell__2Cbmy","headRow":"styles_headRow__10v7W"};